__turbopack_context__.v({
  "partners": "partners-module__u8q3MW__partners",
  "scroller": "partners-module__u8q3MW__scroller",
  "slide": "partners-module__u8q3MW__slide",
  "title": "partners-module__u8q3MW__title",
});
